import {takeLatest, put, all, call} from 'redux-saga/effects';
import {successToast} from '../actions';
import * as AC from '../actions/actionTypes';
import {addPdfReportApi, getPdfPayloadByIdApi, getPdfReportsApi, getPdfReportsByNameApi, sendPdfByMailApi} from '../api/pdfReports.service';
import {errorHandler} from '../utils/errorHandler';
import history from '../routes/history';
import { sendPdfByMail } from '../actions/pdfReportsActions';

function* getPdfReportsSaga(fn) {
  try {
    const response = yield call(getPdfReportsApi, fn.filters);
    yield put({
      type: AC.GET_PDF_REPORT_SUCCEED,
      payload: response.data.data,
      page: response.data.page,
      totalPages: response.data.totalPages,
      templateType: fn.filters.templateType,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_PDF_REPORT_FAILED);
  }
}

function* getPdfReportsByNameSaga(fn) {
  try {
    const response = yield call(getPdfReportsByNameApi, fn.elevatorName ,fn.filters);
    yield put({
      type: AC.GET_PDF_REPORT_BY_NAME_SUCCEED,
      payload: response.data.data,
      page: response.data.page,
      totalPages: response.data.totalPages,
      templateType: fn.filters.templateType,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_PDF_REPORT_BY_NAME_FAILED);
  }
}

function* addPdfReportSaga(fn) {
  try {
    const response = yield call(addPdfReportApi, fn.payload);
    yield put({
      type: AC.ADD_PDF_REPORT_SUCCEED,
      payload: response.data,
      filters: {templateType: fn.payload.templateType},
    });
    yield put(successToast('Report generated successfully!'));
    history.back();
  } catch (e) {
    yield errorHandler(e, AC.ADD_PAYMENT_FAILED);
  }
}

function* getPdfPayloadByIdSaga(fn) {
  try {
    const response = yield call(getPdfPayloadByIdApi, fn.id);
    yield put({
      type: AC.GET_PDF_PAYLOAD_BY_ID_SUCCEED,
      payload: response.data,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_PDF_PAYLOAD_BY_ID_FAILED);
  }
}

function* sendPdfByMailSaga(fn) {
  try {
    const formData = fn.payload; 

    const response = yield call(sendPdfByMailApi, formData); 
    
    yield put({
      type: AC.SEND_PDF_REPORT_EMAIL_SUCCEED,
      payload: response.data,
    });
    
    yield put(successToast('Email sent successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.SEND_PDF_REPORT_EMAIL_FAILED);
  }
}


function* actionWatcher() {
  yield takeLatest([AC.GET_PDF_REPORT_REQUEST], getPdfReportsSaga);
  yield takeLatest([AC.GET_PDF_PAYLOAD_BY_ID_REQUEST], getPdfPayloadByIdSaga);
  yield takeLatest([AC.GET_PDF_REPORT_BY_NAME_REQUEST], getPdfReportsByNameSaga);
  yield takeLatest(AC.ADD_PDF_REPORT_REQUEST, addPdfReportSaga);
  yield takeLatest(AC.SEND_PDF_REPORT_EMAIL_REQUEST, sendPdfByMailSaga);
}

export default function* pdfReportsSaga() {
  yield all([actionWatcher()]);
}
